import React from 'react';
import UsefullNumericInput from './UsefullNumericInput';

const UseMatrixRowInput = (props) => {
  const {
    index,
    onChange,
    value,
    minval,
    stepMm,
    units,
    ...restProps
  } = props;
  
  return (
    <UsefullNumericInput
      {...restProps}
      onChange={data => {
        return onChange({ data: data, index: index, changed: true })
      }}
      value={value}
      step={1}
      minval={minval}
    />
  )
};

export default React.memo(UseMatrixRowInput);
